module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [(!_vm.localContact.isNew) ? _c('el-checkbox', {
    staticClass: "pull-right",
    on: {
      "change": _vm.hasChanged
    },
    model: {
      value: (_vm.remove),
      callback: function($$v) {
        _vm.remove = $$v
      },
      expression: "remove"
    }
  }, [_vm._v("Poista")]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.remove
    }
  }, [_c('label', {
    attrs: {
      "for": 'name' + _vm.localContact.id
    }
  }, [_vm._v("Nimi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localContact.name),
      expression: "localContact.name"
    }],
    attrs: {
      "disabled": _vm.remove,
      "id": 'name' + _vm.localContact.id,
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.localContact.name)
    },
    on: {
      "change": _vm.hasChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localContact.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'title' + _vm.localContact.id
    }
  }, [_vm._v("Titteli")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localContact.title),
      expression: "localContact.title"
    }],
    attrs: {
      "disabled": _vm.remove,
      "id": 'title' + _vm.localContact.id,
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.localContact.title)
    },
    on: {
      "change": _vm.hasChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localContact.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'email' + _vm.localContact.id
    }
  }, [_vm._v("Sähköposti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localContact.email),
      expression: "localContact.email"
    }],
    attrs: {
      "disabled": _vm.remove,
      "id": 'email' + _vm.localContact.id,
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.localContact.email)
    },
    on: {
      "change": _vm.hasChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localContact.email = $event.target.value
      }
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e7f185"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Contact.vue
// module id = 449
// module chunks = 0